// Path: ./src/app/pages/CreateDealTab/handleSaveDeals.ts
import {
  UpdateGfPlacementDto,
  UpdateGfProductDto,
  UpdateGfPromotionDto,
} from "@swagger/typescript-fetch-goflyer";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import { getShowAt } from "../../../utils/getShowAt";
import { setValidationStartTimeTo1201AM } from "../../../utils/dateUtil/setTimeTo1201AM";
import { setValidationEndTimeTo1159PM } from "../../../utils/dateUtil/setTimeTo1159PM";
import i18n from "i18next";
import { useLoading } from "../../../contextApi/LoadingContext";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import { useContext } from "react";

export const useHandleSaveDeal = () => {
  const { state } = useContext(GoFlyerAdminContext);
  const { showLoadingScreen } = useLoading();
  const handleSaveDeal = async (
    storeWebsite: boolean,
    goFlyerWebsite: boolean,
    updateProduct?: UpdateGfProductDto,
    updatePlacement?: UpdateGfPlacementDto,
    updatePromotion?: UpdateGfPromotionDto
  ) => {
    if (!updateProduct?.name) {
      toastError(`${i18n.t(messages.name())} ${i18n.t(messages.is_Empty())}`);
      return;
    }

    if (!updateProduct?.gfImages || updateProduct?.gfImages.length === 0) {
      toastError(
        `${i18n.t(messages.Product_Images())} ${i18n.t(messages.is_Empty())}`
      );
      return;
    }

    if (!updatePlacement?.store) {
      toastError(`${i18n.t(messages.Stores())} ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updatePromotion?.price) {
      toastError(
        `${i18n.t(messages.Sale_Price())} ${i18n.t(messages.is_Empty())}`
      );
      return;
    }
    if (!updatePromotion?.unit || !updatePromotion?.unitV2) {
      toastError(`${i18n.t(messages.Unit())} ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updatePromotion?.validStartDate) {
      toastError(
        `${i18n.t(messages.validStartDate())} ${i18n.t(messages.is_Empty())}`
      );
      return;
    }
    if (!updatePromotion?.validEndDate) {
      toastError(
        `${i18n.t(messages.validEndDate())} ${i18n.t(messages.is_Empty())}`
      );
      return;
    }

    if (!state.gfAdminUser) {
      toastError(
        `${i18n.t(messages.There_is_an_error_please_Contact_Administrator())}`
      );
      return;
    }

    showLoadingScreen(true);
    /**
     * TODO: could create a new api on the backend to call these 3 thing
     */

    const createdProduct = updateProduct?.id
      ? await adminApiService.updateOneBaseGfProductAdminControllerGfProduct(
          updateProduct,
          updateProduct.id
        )
      : await adminApiService.createOneBaseGfProductAdminControllerGfProduct({
          ...updateProduct, //This is for optional properties
          name: updateProduct.name,
          gfImages: updateProduct.gfImages,
        }); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) ideally, we don't want to re create a object here, will come back for a better solution

    const createdPlacement = updatePlacement.id
      ? await adminApiService.updateOneBaseGfPlacementAdminControllerGfPlacement(
          updatePlacement, //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) ts not complaining here since updatePlacement is all optional. so even we put updateProduct. it will also work.
          updatePlacement.id
        )
      : await adminApiService.createOneBaseGfPlacementAdminControllerGfPlacement(
          {
            ...updatePlacement, //This is for optional properties
            product: createdProduct,
            store: updatePlacement?.store,
          }
        );

    updatePromotion.id
      ? await adminApiService.updateOneBaseGfPromotionAdminControllerGfPromotion(
          {
            ...updatePromotion,
            showAt: getShowAt(storeWebsite, goFlyerWebsite), //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) temp solution
            validStartDate: setValidationStartTimeTo1201AM(
              updatePromotion.validStartDate
            ),
            validEndDate: setValidationEndTimeTo1159PM(
              updatePromotion.validEndDate
            ),
          },
          updatePromotion.id
        )
      : await adminApiService.createOneBaseGfPromotionAdminControllerGfPromotion(
          {
            ...updatePromotion, //This is for optional properties
            price: updatePromotion?.price,
            placement: createdPlacement,
            unit: updatePromotion.unit,
            unitV2: updatePromotion.unitV2,
            validStartDate: setValidationStartTimeTo1201AM(
              updatePromotion.validStartDate
            ),
            validEndDate: setValidationEndTimeTo1159PM(
              updatePromotion.validEndDate
            ),
            showAt: getShowAt(storeWebsite, goFlyerWebsite), //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) not a good idea
            adminUser: state.gfAdminUser,
          }
        );

    showLoadingScreen(false);
    toastSuccess(i18n.t(messages.Deal_Added_Successfully()));
  };
  return handleSaveDeal;
};
